// ProtectedRoute.tsx
import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as authActions from "src/redux/slices/authTenantSlice";
import { getFromStorage } from "src/utils/storage";
import storageKeys from "src/constants/storage";
import Spinner from "../ui/Spinner";

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.authTenant);

  const authToken = getFromStorage(storageKeys.authTenantToken);
  // const userInfo = getFromStorage(storageKeys.userInfo);

  useEffect(() => {
    if (authToken && !user?.data && !user?.error && !user?.loading) {
      dispatch(authActions.getUserDetailsRequest());
      // dispatch(authActions.setUser(JSON.parse(userInfo)));
    }
  }, [authToken, dispatch, user]);

  if (!authToken || (!user?.data && user?.error && !user?.loading)) {
    return <Navigate to="/app/login" replace />;
  }

  if (user?.loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spinner />
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
